import Joi from 'joi';

export const schema = Joi.object().keys({
  amountRefunded: Joi.number().allow(null).label('amountRefunded'),
  closeDate: Joi.date().allow(null).label('Close Date'),
  reviewerComments: Joi.array().label('reviewerComments'),
});
